import { gql } from '@apollo/client';

/** The organization fields every screen reads from `users.organization`, real or simulated. */
export const ORGANIZATION_FIELDS = gql`
    fragment OrganizationFields on organizations {
        organization_id
        name
        week_starts_on
    }
`;
